const gsap = window.gsap;

if (gsap !== undefined) {
  document.querySelectorAll(".section_shortcuts").forEach((section) => {
    gsap.from(section.querySelectorAll(".col"), {
      autoAlpha: 0,
      opacity: 0,
      y: 20,
      duration: 1,
      stagger: 0.1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
      },
    });
  });
}
